"use client";

import { Input } from "@/components/ui/input";
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTrigger
} from "@/components/ui/sheet";
import { useDebounce } from "@/src/hooks/useDebounce";
import { Loader2 } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

interface SearchProductType {
    status: number;
    message: string;
    data: DataSearchProductType;
}

interface DataSearchProductType {
    count: number;
    rows: RowSearchProductType[];
}

interface RowSearchProductType {
    product_title: string;
    product_title_second: string;
    product_url: string;
    product_image: string;
    ProductIdentities: ProductIdentity[];
}

interface ProductIdentity {
    id: number;
    ProductId: number;
    Warehouses: Warehouse[];
    Albums: Albums[];
}

interface Albums {
    id: number;
    album_image_alt: string;
    album_image_src: string;
    ProductIdentityId: number;
}

interface Warehouse {
    id: number;
    warehouse_count: number;
    warehouse_price: number;
    warehouse_discount: number;
    warehouse_price_vip: number;
    warehouse_discount_vip: number;
    warehouse_available: boolean;
    ProductIdentityId: number;
    ProductId: number;
}

const InputSearch = () => {
    const [valueSearch, setValueSearch] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [listSearch, setListSearch] = useState<RowSearchProductType[]>([]);
    const value = useDebounce(valueSearch, 500);

    useEffect(() => {
        const GetSearch = async () => {
            try {
                setLoading(true);
                const res = await fetch(`${process.env.BASE_URL}/search-do-search/${value}`);
                const data: SearchProductType = await res.json();
                setLoading(false);
                setListSearch(data.data.rows);
            } catch (error) {
                console.error("Error fetching search results:", error);
                setLoading(false);
                setListSearch([]);
            }
        };

        if (value.length > 3) {
            GetSearch();
        } else {
            setListSearch([]);
        }
    }, [value]);

    const onClose = () => {
        setListSearch([]);
        setValueSearch("");
    };

    return (
        <Sheet onOpenChange={onClose} open={listSearch.length > 0}>
            <SheetTrigger asChild>
                <div className="relative m-2">
                    <Input
                        placeholder="نام کالای مورد نظر را وارد کنید"
                        value={valueSearch}
                        onChange={(e) => setValueSearch(e.target.value)}
                    />
                    <span className="absolute top-1 left-1">
                        {loading ? (
                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                            </svg>
                        )}
                    </span>
                </div>
            </SheetTrigger>
            <SheetContent className="overflow-auto h-[100vh]  dark:bg-slate-700" side="bottom">
                <div className="relative m-2">
                    <Input
                        placeholder="نام کالای مورد نظر را وارد کنید"
                        value={valueSearch}
                        onChange={(e) => setValueSearch(e.target.value)}
                    />
                    <span className="absolute top-1 left-1">
                        {loading ? (
                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                            </svg>
                        )}
                    </span>
                </div>
                {listSearch.length > 0 ? (
                    listSearch.map((data, index) => (
                        <div
                            key={index}
                            onClick={onClose}
                            className="h-[350px] w-[235px] rounded text-center mx-auto relative p-2"
                        >
                            <div className="h-[350px] mx-auto overflow-hidden">
                                <Link href={`/product/${data.product_url.replace(/ /g, "-")}`}>
                                    <div className="aspect-w-1 aspect-h-1">
                                        <Image
                                            alt={data.product_title}
                                            src={`${process.env.imageUrl}${data.product_image}`}
                                            fill
                                            className="object-cover rounded-md"
                                            priority
                                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mOcvOVYPQAGfQKOiuBnlQAAAABJRU5ErkJggg=="
                                            placeholder="blur"
                                        />
                                    </div>
                                </Link>
                            </div>
                            <div className="p-1 w-[90%] bg-purple-100 dark:bg-slate-600 absolute bottom-4 left-1/2 transform -translate-x-1/2 shadow-lg rounded bg-opacity-75 dark:bg-opacity-75">
                                <div className="px-1">
                                    <p className="text-lg truncate">{data.product_title}</p>
                                </div>
                            </div>
                        </div>
                    ))
                ) : null}
            </SheetContent>
        </Sheet>
    );
};

export default InputSearch;
